import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosItinerarioEmbarque from './FiltrosAdicionadosItinerarioEmbarque';
import PainelFiltragem from '../comum/PainelFiltragem'
import FiltroItinerarioEmbarque from './FiltroItinerarioEmbarque';
import CampoBuscaItinerarioEmbarque from './CampoBuscaItinerarioEmbarque';

export const PainelFiltroItinerarioEmbarque = () => (
  <Filtro PainelFiltro={FiltroItinerarioEmbarque}/>
);

const PainelFiltrosItinerarioEmbarque = () => (
  <PainelFiltragem
    CampoBusca={CampoBuscaItinerarioEmbarque}
    Filtro={PainelFiltroItinerarioEmbarque}
    FiltrosAdicionados={FiltrosAdicionadosItinerarioEmbarque}/>
)

export default PainelFiltrosItinerarioEmbarque
